const sortSelected = (selected, categoriesMap) =>
  selected.sort((id1, id2) => {
    return categoriesMap[id1].Order - categoriesMap[id2].Order;
  });

export default sortSelected;
